/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Dapatkan akses kepada editor HTML yang menarik"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Penyemak Kebolehcapaian"
  },
  "action_to_take_b626a99a": {
    "message": "Tindakan untuk dilakukan:"
  },
  "add_8523c19b": {
    "message": "Tambah"
  },
  "add_a_caption_2a915239": {
    "message": "Tambah kapsyen"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Tambah teks alt untuk imej"
  },
  "add_another_f4e50d57": {
    "message": "Tambah yang lain"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Tambah CC/Sari Kata"
  },
  "add_image_60b2de07": {
    "message": "Tambah Imej"
  },
  "add_one_9e34a6f8": {
    "message": "Tambah satu!"
  },
  "additional_considerations_f3801683": {
    "message": "Pertimbangan tambahan"
  },
  "address_applied_64269b0b": {
    "message": "Alamat digunakan"
  },
  "address_removed_fcb496e0": {
    "message": "Alamat dialih keluar"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Pautan berhampiran dengan URL yang sama sepatutnya dijadikan pautan tunggal."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Jajarkan"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Penjajaran dan Senarai"
  },
  "all_4321c3a1": {
    "message": "Semua"
  },
  "all_apps_a50dea49": {
    "message": "Semua Apl"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Benarkan muat turun media"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Benarkan muat turun transkrip"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Mengikut abjad"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Teks atribut alt tidak boleh mengandungi lebih daripada 120 aksara."
  },
  "alt_text_611fb322": {
    "message": "Teks Alt"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Produk Bersama)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Ralat berlaku semasa membaca fail"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Ralat berlaku semasa membuat permintaan rangkaian"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Ralat berlaku semasa memuat naik media anda."
  },
  "and_7fcc2911": {
    "message": "Dan"
  },
  "angle_c5b4ec50": {
    "message": "Sudut"
  },
  "announcement_fb4cb645": {
    "message": "Pengumuman"
  },
  "announcement_list_da155734": {
    "message": "Senarai Pengumuman"
  },
  "announcements_a4b8ed4a": {
    "message": "Pengumuman"
  },
  "apply_781a2546": {
    "message": "Gunakan"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Gunakan perubahan pada semua tika Ikon Pembuat Ikon ini dalam Kursus"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Hampir Mencapai Had"
  },
  "approximately_e7965800": {
    "message": "Anggaran"
  },
  "apps_54d24a47": {
    "message": "Aplikasi"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Adakah anda pasti anda ingin membatalkan? Perubahan yang anda lakukan mungkin belum disimpan."
  },
  "arrows_464a3e54": {
    "message": "Anak panah"
  },
  "art_icon_8e1daad": {
    "message": "Ikon Seni"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Nisbah aspek akan dikekalkan"
  },
  "assignment_976578a8": {
    "message": "Tugasan"
  },
  "assignments_1e02582c": {
    "message": "Tugasan"
  },
  "asterisk_82255584": {
    "message": "Simbol berbentuk bintang"
  },
  "attributes_963ba262": {
    "message": "Atribut"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Rakaman audio dan video tidak disokong; sila gunakan pelayar lain."
  },
  "audio_options_feb58e2c": {
    "message": "Pilihan Audio"
  },
  "audio_options_tray_33a90711": {
    "message": "Dulang Pilihan Audio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Pemain audio untuk { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Kandungan yang disimpan secara automatik wujud. Adakah anda ingin memuat naik kandungan yang disimpan secara automatik sebagai ganti?"
  },
  "available_folders_694d0436": {
    "message": "Folder tersedia"
  },
  "background_1bc88842": {
    "message": "Latar Belakang"
  },
  "backslash_b2d5442d": {
    "message": "Garis miring balik"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Asas"
  },
  "because_501841b": {
    "message": "Sebab"
  },
  "below_81d4dceb": {
    "message": "Di bawah"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Bulatan Besar"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Pekali Binomial"
  },
  "black_4cb01371": {
    "message": "Hitam"
  },
  "blue_daf8fea9": {
    "message": "Biru"
  },
  "bold_applied_42d547b7": {
    "message": "Tebal digunakan"
  },
  "bold_removed_da474a5c": {
    "message": "Tebal dialih keluar"
  },
  "border_5b08b06d": {
    "message": "Sempadan"
  },
  "bottom_15a2a9be": {
    "message": "Bawah"
  },
  "bottom_third_5f5fec1d": {
    "message": "Bawah Ketiga"
  },
  "bowtie_5f9629e4": {
    "message": "Tali leher kupu-kupu"
  },
  "brick_f2656265": {
    "message": "Batu bata"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Batal"
  },
  "cap_product_3a5265a6": {
    "message": "Hadkan Produk"
  },
  "caption_manager_aae0906f": {
    "message": "Pengurus Kapsyen"
  },
  "center_align_e68d9997": {
    "message": "Jajar ke Tengah"
  },
  "centered_dot_64d5e378": {
    "message": "Titik di Tengah"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Titik Mendatar di Tengah"
  },
  "change_alt_text_92654906": {
    "message": "Ubah teks alt"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Ubah tag pengepala kepada perenggan"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Ubah tahap pengepala ini sahaja"
  },
  "change_text_color_1aecb912": {
    "message": "Ubah warna teks"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Perubahan akan dikenakan selepas anda menyimpan halaman ini."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Perubahan yang anda lakukan mungkin belum disimpan."
  },
  "characters_9d897d1c": {
    "message": "Aksara"
  },
  "characters_no_spaces_485e5367": {
    "message": "Aksara (tiada jarak)"
  },
  "check_accessibility_3c78211c": {
    "message": "Semak Kebolehcapaian"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Menyemak isu kebolehcapaian"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Pilih fail kapsyen "
  },
  "choose_usage_rights_33683854": {
    "message": "Pilih hak penggunaan..."
  },
  "circle_484abe63": {
    "message": "Bulatan"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "Bulatan senarai tidak tersusun"
  },
  "clear_2084585f": {
    "message": "Kosongkan"
  },
  "clear_image_3213fe62": {
    "message": "Kosongkan imej"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klik atau Shift+klik untuk mendapatkan editor html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klik untuk membenam { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klik untuk menyembunyikan pratonton"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klik untuk memasukkan pautan ke dalam editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Klik untuk menunjukkan pratonton"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Tutup menu atau dialog. Juga mengembalikan anda ke kawasan editor"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Tutup Penyemak Kebolehcapaian"
  },
  "close_d634289d": {
    "message": "Tutup"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Tutup Modal Pintasan Papan Kekunci"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Fail kapsyen tertutup mestilah kurang daripada { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Kapsyen/Sari Kata Tertutup"
  },
  "clubs_suit_c1ffedff": {
    "message": "Kelab (Sut)"
  },
  "collab_575ac7bc": {
    "message": "Kerjasama"
  },
  "collaborations_5c56c15f": {
    "message": "Kolaborasi"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Kuncupkan untuk menyembunyikan { types }"
  },
  "color_a363e1b0": {
    "message": "Warna"
  },
  "color_contrast_4c418add": {
    "message": "Kontras Warna"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Nisbah Kontras Warna"
  },
  "color_picker_6b359edf": {
    "message": "Pemilih Warna"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Pemilih Warna ({ colorName } dipilih)"
  },
  "color_popup_af39810f": {
    "message": "Pop timbul warna"
  },
  "column_e1ae5c64": {
    "message": "Lajur"
  },
  "column_group_1c062368": {
    "message": "Kumpulan lajur"
  },
  "complex_numbers_a543d004": {
    "message": "Nombor Kompleks"
  },
  "computer_1d7dfa6f": {
    "message": "Komputer"
  },
  "congruent_5a244acd": {
    "message": "Kongruen"
  },
  "contains_311f37b7": {
    "message": "Mengandungi"
  },
  "content_1440204b": {
    "message": "Kandungan"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Kandungan dalam editor akan diubah. Tekan Batal untuk menyimpan kandungan asal."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Kandungan masih lagi sedang dimuat naik, sekiranya anda meneruskan kandungan tidak akan terbenam dengan betul."
  },
  "content_subtype_5ce35e88": {
    "message": "Sub-jenis Kandungan"
  },
  "content_type_2cf90d95": {
    "message": "Jenis Kandungan"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Teruskan ke kandungan YouTube"
  },
  "coproduct_e7838082": {
    "message": "Produk Bersama"
  },
  "copyright_holder_66ee111": {
    "message": "Pemegang Hak Cipta:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Tidak dapat menyisipkan kandungan: \"{ itemType }\" item tidak disokong dalam Canvas buat masa ini."
  },
  "count_40eced3b": {
    "message": "Kira"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 perkataan}\n    one {1 perkataan}\n  other {# perkataan}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# item dimuat naik}\n  other {# item dimuat naik}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Dokumen Kursus"
  },
  "course_files_62deb8f8": {
    "message": "Fail Kursus"
  },
  "course_files_a31f97fc": {
    "message": "Fail kursus"
  },
  "course_images_f8511d04": {
    "message": "Imej Kursus"
  },
  "course_link_b369426": {
    "message": "Pautan Kursus"
  },
  "course_links_b56959b9": {
    "message": "Pautan Kursus"
  },
  "course_media_ec759ad": {
    "message": "Media Kursus"
  },
  "course_navigation_dd035109": {
    "message": "Navigasi Kursus"
  },
  "create_icon_110d6463": {
    "message": "Cipta Ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Cipta Ikon Pembuat Ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Lesen Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Pangkas imej"
  },
  "crop_image_807ebb08": {
    "message": "Pangkas Imej"
  },
  "cup_product_14174434": {
    "message": "Produk Cawan"
  },
  "current_image_f16c249c": {
    "message": "Imej Semasa"
  },
  "current_link_945a47ee": {
    "message": "Pautan Semasa"
  },
  "current_volume_level_c55ab825": {
    "message": "Tahap Volum Semasa"
  },
  "custom_6979cd81": {
    "message": "Tersuai"
  },
  "cyan_c1d5f68a": {
    "message": "Sian"
  },
  "dagger_57e0f4e5": {
    "message": "Pisau Belati"
  },
  "date_added_ed5ad465": {
    "message": "Tarikh Ditambah"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ikon Hiasan"
  },
  "decorative_image_fde98579": {
    "message": "Imej hiasan"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "{ TYPE_UPPER } Hiasan"
  },
  "decrease_indent_d9cf469d": {
    "message": "Kurangkan Engsot"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Kurangkan Kawasan Kandungan Beraneka"
  },
  "deep_purple_bb3e2907": {
    "message": "Ungu Gelap"
  },
  "default_9db103d": {
    "message": "Lalai"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "Senarai tidak tersusun berbulet lalai"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "Senarai tersusun berbulet lalai"
  },
  "definite_integral_fe7ffed1": {
    "message": "Kamiran Tentu"
  },
  "degree_symbol_4a823d5f": {
    "message": "Simbol Darjah"
  },
  "delimiters_4db4840d": {
    "message": "Pembatas"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Keterangan ikon)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Terangkan { TYPE })"
  },
  "description_436c48d7": {
    "message": "Penerangan"
  },
  "details_98a31b68": {
    "message": "Butiran"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Titik Pepenjuru"
  },
  "diamond_b8dfe7ae": {
    "message": "Berlian"
  },
  "diamonds_suit_526abaaf": {
    "message": "Berlian (Sut)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Jenis Dimensi"
  },
  "directionality_26ae9e08": {
    "message": "Kearahan"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Edit LaTeX secara terus"
  },
  "disable_preview_222bdf72": {
    "message": "Nyahdayakan Pratonton"
  },
  "discussion_6719c51d": {
    "message": "Perbincangan"
  },
  "discussions_a5f96392": {
    "message": "Perbincangan"
  },
  "discussions_index_6c36ced": {
    "message": "Indeks Perbincangan"
  },
  "disjoint_union_e74351a8": {
    "message": "Buka Cantuman Penyambung"
  },
  "display_options_315aba85": {
    "message": "Paparkan Pilihan"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Paparkan Pautan Teks (Dibuka dalam tab baharu)"
  },
  "div_applied_49ad83fc": {
    "message": "Pembahagi digunakan"
  },
  "div_removed_d13f8e17": {
    "message": "Pembahagi dialih keluar"
  },
  "division_sign_72190870": {
    "message": "Papan Tanda Bahagian"
  },
  "document_678cd7bf": {
    "message": "Dokumen"
  },
  "documents_81393201": {
    "message": "Dokumen"
  },
  "done_54e3d4b6": {
    "message": "Siap"
  },
  "double_dagger_faf78681": {
    "message": "Simbol Anotasi"
  },
  "down_5831a426": {
    "message": "Bawah"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Panah Barat Daya"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Panah Tenggara"
  },
  "download_filename_2baae924": {
    "message": "Muat turun { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Panah Tegak Bawah"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Segi Tiga Tunjuk Bawah"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Seret fail di sini"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Seret dan lepas, atau klik untuk melayari komputer anda"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Seret kendali. Gunakan anak panah ke atas dan ke bawah untuk menukar saiz."
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Cukup tempoh: Berbilang Tarikh"
  },
  "due_when_7eed10c6": {
    "message": "Cukup tempoh: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Edit teks alt untuk tika ikon ini"
  },
  "edit_c5fbea07": {
    "message": "Edit"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Edit Pautan Kursus"
  },
  "edit_equation_f5279959": {
    "message": "Edit Persamaan"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Edit Ikon Pembuat Ikon Sedia Ada"
  },
  "edit_icon_2c6b0e91": {
    "message": "Edit Ikon"
  },
  "edit_link_7f53bebb": {
    "message": "Edit Pautan"
  },
  "editor_status_bar_653f44ee": {
    "message": "Bar Status Editor"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elemen bermula dengan { start }"
  },
  "embed_828fac4a": {
    "message": "Benamkan"
  },
  "embed_code_314f1bd5": {
    "message": "Benamkan Kod"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Benamkan kandungan daripada Alat Luar"
  },
  "embed_image_1080badc": {
    "message": "Imej Terbenam"
  },
  "embed_video_a97a64af": {
    "message": "Video Terbenam"
  },
  "embedded_content_aaeb4d3d": {
    "message": "kandungan terbenam"
  },
  "empty_set_91a92df4": {
    "message": "Set Kosong"
  },
  "encircled_dot_8f5e51c": {
    "message": "Dot Dilingkari Bulatan"
  },
  "encircled_minus_72745096": {
    "message": "Simbol Tolak Dilingkari Bulatan"
  },
  "encircled_plus_36d8d104": {
    "message": "Simbol Tambah Dilingkari Bulatan"
  },
  "encircled_times_5700096d": {
    "message": "Masa Dilingkari Bulatan"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ikon Kejuruteraan"
  },
  "english_icon_25bfe845": {
    "message": "Ikon Bahasa Inggeris"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Masukkan tajuk media"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Masukkan sekurang-kurangnya 3 aksara untuk mencari"
  },
  "enter_replacement_text_17631bbc": {
    "message": "Masukkan teks gantian"
  },
  "enter_search_text_26cb4459": {
    "message": "masukkan teks carian"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Varian)"
  },
  "equals_sign_c51bdc58": {
    "message": "Tanda Sama Dengan"
  },
  "equation_1c5ac93c": {
    "message": "Persamaan"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editor Persamaan"
  },
  "equilibrium_6ff3040b": {
    "message": "Keseimbangan"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Kelas Kesetaraan"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Kesetaraan (Identiti)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Wujud"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Keluar dari Skrin Penuh"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Kembangkan pratonton secara Lalai"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Kembangkan untuk melihat { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Pautan Luar"
  },
  "external_tool_frame_70b32473": {
    "message": "Bingkai alat luar"
  },
  "external_tools_6e77821": {
    "message": "Alat Luar"
  },
  "extra_large_b6cdf1ff": {
    "message": "Amat Besar"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Ekstra Besar ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Amat Kecil"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ikon Kurikulum Tambahan"
  },
  "f_function_fe422d65": {
    "message": "F (fungsi)"
  },
  "fail_544e5dde": {
    "message": "GAGAL"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Gagal mendapatkan kandungan fail"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Gagal mengambil kandungan daripada alat luar"
  },
  "file_name_8fd421ff": {
    "message": "Nama fail"
  },
  "file_preview_21667a6e": {
    "message": "Pratonton fail"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Pratonton fail untuk { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Melebihi kuota storan fail"
  },
  "file_url_c12b64be": {
    "message": "URL Fail"
  },
  "filename_file_icon_602eb5de": {
    "message": "Ikon fail { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Pratonton imej { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Pratonton teks { filename }"
  },
  "files_c300e900": {
    "message": "Fail"
  },
  "files_index_af7c662b": {
    "message": "Indeks Fail"
  },
  "find_8d605019": {
    "message": "Cari"
  },
  "find_and_replace_6e345933": {
    "message": "Cari dan Gantikan"
  },
  "finish_bc343002": {
    "message": "Selesai"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Pulihkan hierarki tajuk"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (Muzik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Bar alat pilihan elemen fokus"
  },
  "folder_tree_fbab0726": {
    "message": "Pepohon Folder"
  },
  "for_all_b919f972": {
    "message": "Untuk Semua"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Format sebagai senarai"
  },
  "formatting_5b143aa8": {
    "message": "Pemformatan"
  },
  "forward_slash_3f90f35e": {
    "message": "Garis Miring"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Kandungan yang disimpan secara automatik ditemui"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "{ count, plural,\n     =0 {# hasil}\n    one {# hasil}\n  other {# hasil}\n} ditemui"
  },
  "fraction_41bac7af": {
    "message": "Pecahan"
  },
  "fullscreen_873bf53f": {
    "message": "Skrin penuh"
  },
  "gamma_1767928": {
    "message": "Gama"
  },
  "generating_preview_45b53be0": {
    "message": "Menjana pratonton..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Imej format GIF/PNG lebih besar daripada { size } KB tidak disokong pada masa ini."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Terus ke bar menu editor"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Terus ke bar alat editor"
  },
  "grades_a61eba0a": {
    "message": "Gred"
  },
  "graphics_text_bc9568bc": {
    "message": "Teks grafik"
  },
  "greater_than_e98af662": {
    "message": "Lebih Besar Daripada"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Lebih Besar Daripada atau Sama Dengan"
  },
  "greek_65c5b3f7": {
    "message": "Bahasa Greek"
  },
  "green_15af4778": {
    "message": "Hijau"
  },
  "grey_a55dceff": {
    "message": "Kelabu"
  },
  "group_documents_8bfd6ae6": {
    "message": "Dokumen Kumpulan"
  },
  "group_files_4324f3df": {
    "message": "Fail Kumpulan"
  },
  "group_files_82e5dcdb": {
    "message": "Fail Kumpulan"
  },
  "group_images_98e0ac17": {
    "message": "Imej Kumpulan"
  },
  "group_isomorphism_45b1458c": {
    "message": "Isomorfisme Kumpulan"
  },
  "group_link_63e626b3": {
    "message": "Pautan Kumpulan"
  },
  "group_links_9493129e": {
    "message": "Pautan Kumpulan"
  },
  "group_media_2f3d128a": {
    "message": "Media Kumpulan"
  },
  "group_navigation_99f191a": {
    "message": "Navigasi Kumpulan"
  },
  "h_bar_bb94deae": {
    "message": "Bar H"
  },
  "hat_ea321e35": {
    "message": "Topi"
  },
  "header_column_f27433cb": {
    "message": "Lajur pengepala"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Baris dan lajur pengepala"
  },
  "header_row_f33eb169": {
    "message": "Baris pengepala"
  },
  "heading_2_5b84eed2": {
    "message": "Pengepala 2"
  },
  "heading_3_2c83de44": {
    "message": "Pengepala 3"
  },
  "heading_4_b2e74be7": {
    "message": "Pengepala 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Pengepala { h } digunakan"
  },
  "heading_h_removed_745f24a6": {
    "message": "Pengepala { h } dialih keluar"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Tahap tajuk tidak boleh dilangkau."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Tajuk bermula dengan { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Tajuk tidak boleh mengandungi lebih daripada 120 aksara."
  },
  "health_icon_8d292eb5": {
    "message": "Ikon Kesihatan"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hati (Sut)"
  },
  "height_69b03e15": {
    "message": "Ketinggian"
  },
  "hexagon_d8468e0d": {
    "message": "Heksagon"
  },
  "hide_description_bfb5502e": {
    "message": "Sembunyikan penerangan"
  },
  "hide_title_description_caf092ef": {
    "message": "Sembunyikan penerangan { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Serlahkan elemen untuk mengaktifkan bar alat pilihan elemen"
  },
  "home_351838cd": {
    "message": "Laman Utama"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Bagaimanakah cara untuk meminta dan mengedit kapsyen?"
  },
  "html_code_editor_fd967a44": {
    "message": "editor kod html"
  },
  "html_editor_fb2ab713": {
    "message": "Editor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Saya telah mendapatkan keizinan untuk menggunakan fail ini."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Saya memegang hak cipta"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "ikon"
  },
  "icon_color_b86dd6d6": {
    "message": "Warna Ikon"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikon Pembuat Ikon"
  },
  "icon_options_7e32746e": {
    "message": "Pilihan Ikon"
  },
  "icon_options_tray_2b407977": {
    "message": "Dulang Pilihan Ikon"
  },
  "icon_preview_1782a1d9": {
    "message": "Pratonton Ikon"
  },
  "icon_shape_30b61e7": {
    "message": "Bentuk Ikon"
  },
  "icon_size_9353edea": {
    "message": "Saiz Ikon"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Jika ditinggalkan kosong, teks pautan akan dipaparkan sebagai nama pautan kursus"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Jika Hak Penggunaan disyaratkan, fail ini tidak akan terbit sehingga didayakan dalam halaman Fail."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Jika anda tidak memilih hak penggunaan sekarang, fail ini tidak akan diterbitkan selepas ia dimuat naik."
  },
  "image_8ad06": {
    "message": "Imej"
  },
  "image_c1c98202": {
    "message": "imej"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Nama fail imej tidak boleh digunakan sebagai atribut alt yang menerangkan kandungan imej."
  },
  "image_options_5412d02c": {
    "message": "Pilihan Imej"
  },
  "image_options_tray_90a46006": {
    "message": "Dulang Pilihan Imej"
  },
  "image_to_crop_3a34487d": {
    "message": "Imej untuk dipangkas"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Imej dengan nama fail { file }"
  },
  "images_7ce26570": {
    "message": "Imej"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Imej patut termasuk atribut alt yang menerangkan kandungan imej."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Bahagian Khayalan (Nombor Kompleks)"
  },
  "in_element_of_19ca2f33": {
    "message": "Dalam (Element untuk)"
  },
  "increase_indent_6af90f7c": {
    "message": "Tambah Engsot"
  },
  "increase_rich_content_area_340b775": {
    "message": "Tambahkan Kawasan Kandungan Beraneka"
  },
  "indefinite_integral_6623307e": {
    "message": "Kamiran Tidak Tentu"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } daripada { max }"
  },
  "indigo_2035fc55": {
    "message": "Biru Nila"
  },
  "inference_fed5c960": {
    "message": "Inferens"
  },
  "infinity_7a10f206": {
    "message": "Infiniti"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Medan input untuk alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Medan input untuk biru"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Medan input untuk hijau"
  },
  "input_field_for_red_86a84615": {
    "message": "Medan input untuk merah"
  },
  "insert_593145ef": {
    "message": "Sisipkan"
  },
  "insert_link_6dc23cae": {
    "message": "Sisipkan Pautan"
  },
  "insert_math_equation_57c6e767": {
    "message": "Sisipkan Persamaan Matematik"
  },
  "integers_336344e1": {
    "message": "Integer"
  },
  "intersection_cd4590e4": {
    "message": "Persilangan"
  },
  "invalid_description_991e23bb": {
    "message": "Perihalan tidak sah"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Masukan tidak sah."
  },
  "invalid_file_c11ba11": {
    "message": "Fail Tidak Sah"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Jenis fail tidak sah"
  },
  "invalid_url_cbde79f": {
    "message": "URL tidak sah"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Isu { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Italik digunakan"
  },
  "italic_removed_17cbab6f": {
    "message": "Italik dialih keluar"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Varian)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Pintasan Papan Kekunci"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Papan kekunci menavigasi ke pautan menggunakan kekunci Tab. Dua pautan berhampiran yang menghala ke destinasi yang sama boleh mengelirukan pengguna papan kekunci."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ikon Seni Bahasa"
  },
  "languages_icon_9d20539": {
    "message": "Ikon Bahasa"
  },
  "large_9c5e80e7": {
    "message": "Besar"
  },
  "large_text_e7ba08cd": {
    "message": "Teks besar"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Besar ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Belajar"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Ketahui lebih lanjut tentang pautan berhampiran"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Ketahui lebih lanjut tentang kontras warna"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Ketahui lebih lanjut tentang menyusun atur tajuk halaman"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Ketahui lebih lanjut tentang struktur pengepala halaman yang betul"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Ketahui lebih lanjut tentang pengepala jadual"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Ketahui lebih lanjut tentang menggunakan teks alt untuk imej"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Ketahui lebih lanjut tentang menggunakan kapsyen dengan jadual"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Ketahui lebih lanjut tentang menggunakan nama fail sebagai teks alt"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Ketahui lebih lanjut tentang menggunakan senarai"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Ketahui lebih lanjut tentang menggunakan atribut skop dengan jadual"
  },
  "leave_as_is_4facfe55": {
    "message": "Biarkan seperti adanya"
  },
  "left_3ea9d375": {
    "message": "Kiri"
  },
  "left_align_43d95491": {
    "message": "Jajar ke Kiri"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Tanda Kurung Sudut Kiri"
  },
  "left_arrow_4fde1a64": {
    "message": "Panah Kiri"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Panah Cangkuk Kiri"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Siling Kiri"
  },
  "left_curly_brace_1726fb4": {
    "message": "Tanda Kurung Dakap Kiri"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Panah Tempuling Tegak Bawah Kiri"
  },
  "left_floor_29ac2274": {
    "message": "Lantai Kiri"
  },
  "left_to_right_e9b4fd06": {
    "message": "Kiri ke Kanan"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Panah Tempuling Tegak Atas Kiri"
  },
  "leftward_arrow_1e4765de": {
    "message": "Panah Tunjuk Kiri"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Segi Tiga Tunjuk Kiri"
  },
  "less_than_a26c0641": {
    "message": "Kurang Daripada"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Kurang Daripada atau Sama Dengan"
  },
  "library_icon_ae1e54cf": {
    "message": "Ikon Pustaka"
  },
  "light_blue_5374f600": {
    "message": "Biru Muda"
  },
  "link_7262adec": {
    "message": "Pautan"
  },
  "link_options_a16b758b": {
    "message": "Pilihan Pautan"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "jenis pautan: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Pautan dengan teks bermula dengan { start }"
  },
  "links_14b70841": {
    "message": "Pautan"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Pautan ke laman luar."
  },
  "lists_cd1336fc": {
    "message": "Senarai"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Senarai sepatutnya diformatkan sebagai senarai."
  },
  "load_more_35d33c7": {
    "message": "Muatkan Lebih Banyak"
  },
  "loading_25990131": {
    "message": "Memuatkan..."
  },
  "loading_bde52856": {
    "message": "Memuatkan"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "memuatkan kapsyen/sari kata tertutup gagal."
  },
  "loading_external_tool_d839042c": {
    "message": "Memuatkan Alat Luar"
  },
  "loading_failed_b3524381": {
    "message": "Pemuatan gagal..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Pemuatan gagal."
  },
  "loading_folders_d8b5869e": {
    "message": "Memuatkan folder"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Memuatkan ruang letak untuk { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Sedang memuatkan, sila tunggu"
  },
  "loading_preview_9f077aa1": {
    "message": "Memuatkan pratonton"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Kunci kelajuan pada 1x"
  },
  "locked_762f138b": {
    "message": "Berkunci"
  },
  "logical_equivalence_76fca396": {
    "message": "Kesetaraan Logik"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Kesetaraan Logik (Pendek)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Kesetaraan Logik (Pendek dan Tebal)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Kesetaraan Logik (Tebal)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Titik Melintang Rendah"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Peta Untuk"
  },
  "math_icon_ad4e9d03": {
    "message": "Ikon Matematik"
  },
  "media_af190855": {
    "message": "Media"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Fail media sedang diproses. Sila cuba semula kemudian."
  },
  "media_options_saved_560c4ec8": {
    "message": "Pilihan media disimpan."
  },
  "media_title_2112243b": {
    "message": "Tajuk Media"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Sederhana ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Gabung pautan"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon Dinyahdayakan"
  },
  "middle_27dc1d5": {
    "message": "Tengah"
  },
  "minimize_file_preview_da911944": {
    "message": "Kecilkan Pratonton Fail"
  },
  "minimize_video_20aa554b": {
    "message": "Kecilkan Video"
  },
  "minus_fd961e2e": {
    "message": "Tolak"
  },
  "minus_plus_3461f637": {
    "message": "Tolak/Tambah"
  },
  "misc_3b692ea7": {
    "message": "Lain-lain"
  },
  "miscellaneous_e9818229": {
    "message": "Lain-lain"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Modul"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Mengalih imej untuk memangkas { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Imej Pelbagai Warna"
  },
  "multiplication_sign_15f95c22": {
    "message": "Tanda Darab"
  },
  "music_icon_4db5c972": {
    "message": "Ikon Muzik"
  },
  "my_files_2f621040": {
    "message": "Fail saya"
  },
  "n_th_root_9991a6e4": {
    "message": "Akar ke-n"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nama"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Semula Jadi (Muzik)"
  },
  "natural_numbers_3da07060": {
    "message": "Nombor Semula Jadi"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigasi melalui menu atau bar alat"
  },
  "navigation_ee9af92d": {
    "message": "Navigasi"
  },
  "nested_greater_than_d852e60d": {
    "message": "Lebih Daripada Tersarang"
  },
  "nested_less_than_27d17e58": {
    "message": "Kurang Daripada Tersarang"
  },
  "new_quiz_34aacba6": {
    "message": "Kuiz Baharu"
  },
  "next_40e12421": {
    "message": "Seterusnya"
  },
  "next_findtext_9d69f0fe": {
    "message": "Seterusnya { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Tiada isu kebolehcapaian dikesan."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Belum ada pengumuman dicipta."
  },
  "no_announcements_found_20185afc": {
    "message": "Tiada pengumuman ditemui."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Belum ada tugasan dicipta."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Tiada tugasan ditemui."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Tiada perubahan disimpan."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Belum ada perbincangan dicipta."
  },
  "no_discussions_found_9284063b": {
    "message": "Tiada perbincangan ditemui."
  },
  "no_e16d9132": {
    "message": "Tidak"
  },
  "no_file_chosen_9a880793": {
    "message": "Tiada fail dipilih"
  },
  "no_headers_9bc7dc7f": {
    "message": "Tiada pengepala"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Belum ada modul dicipta."
  },
  "no_modules_found_2df43a40": {
    "message": "Tiada modul ditemui."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Belum ada halaman dicipta."
  },
  "no_pages_found_6799350": {
    "message": "Tiada halaman ditemui."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Tiada pratonton tersedia untuk fail ini."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Belum ada kuiz dicipta."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Tiada kuiz dicipta."
  },
  "no_results_940393cf": {
    "message": "Tiada hasil."
  },
  "no_results_found_58717065": {
    "message": "Tiada hasil ditemui"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Tiada hasil ditemui untuk { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Tiada Video"
  },
  "none_3b5e34d2": {
    "message": "Tiada"
  },
  "none_selected_b93d56d2": {
    "message": "Tiada Yang Dipilih"
  },
  "normal_text_7b03da48": {
    "message": "Teks biasa"
  },
  "not_equal_6e2980e6": {
    "message": "Tidak Sama Dengan"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Bukan Dalam (Bukan Unsur Dalam)"
  },
  "not_negation_1418ebb8": {
    "message": "Bukan (Penafian)"
  },
  "not_subset_dc2b5e84": {
    "message": "Bukan Subset"
  },
  "not_subset_strict_23d282bf": {
    "message": "Bukan Subset (Wajar)"
  },
  "not_superset_5556b913": {
    "message": "Bukan Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Bukan Superset (Wajar)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Oktagon"
  },
  "olive_6a3e4d6b": {
    "message": "Zaitun"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Salah satu daripada gaya berikut mesti ditambah untuk menyimpan ikon: Warna Ikon, Saiz Garis Luar, Teks Ikon atau Imej"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Satu atau lebih fail gagal ditampalkan. Sila cuba muat naik atau seret dan lepas fail."
  },
  "open_circle_e9bd069": {
    "message": "Bulatan Terbuka"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Buka dialog pintasan papan kekunci ini"
  },
  "open_title_application_fd624fc5": {
    "message": "Buka aplikasi { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operator"
  },
  "options_3ab0ea65": {
    "message": "Pilihan"
  },
  "or_9b70ccaa": {
    "message": "Atau"
  },
  "orange_81386a62": {
    "message": "Oren"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Senarai Tersusun dan Tidak Tersusun"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Pintasan editor lain boleh ditemui di"
  },
  "outline_color_3ef2cea7": {
    "message": "Warna Garis Luar"
  },
  "outline_size_a6059a21": {
    "message": "Saiz Garis Luar"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } bukan protokol yang sah."
  },
  "page_50c4823d": {
    "message": "Halaman"
  },
  "pages_e5414c2c": {
    "message": "Halaman"
  },
  "paragraph_5e5ad8eb": {
    "message": "Perenggan"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Perenggan digunakan"
  },
  "paragraph_removed_d09320e": {
    "message": "Perenggan dialih keluar"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Perenggan bermula dengan { start }"
  },
  "parallel_d55d6e38": {
    "message": "Selari"
  },
  "partial_derivative_4a9159df": {
    "message": "Separa (Terbitan)"
  },
  "pass_1c19a2b3": {
    "message": "LULUS"
  },
  "paste_5963d1c1": {
    "message": "Tampal"
  },
  "pause_12af3bb4": {
    "message": "Jedakan"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "Orang"
  },
  "percentage_34ab7c2c": {
    "message": "Peratusan"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Peratusan mesti suatu nombor"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Peratusan mestilah sekurang-kurangnya { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ikon Seni Persembahan"
  },
  "perpendicular_7c48ede4": {
    "message": "Serenjang"
  },
  "phi_4ac33b6d": {
    "message": "Fi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Fi (Varian)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikon Pendidikan Jasmani"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Varian)"
  },
  "pick_a_color_557abfb0": {
    "message": "Pilih warna"
  },
  "pink_68ad45cb": {
    "message": "Merah jambu"
  },
  "pixels_52ece7d1": {
    "message": "Piksel"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Piksel mestilah sekurang-kurangnya { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Mainkan"
  },
  "play_media_comment_35257210": {
    "message": "Mainkan komen main."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Mainkan komen media oleh { name } dari { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Tataletak pemain"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Sila benarkan Canvas mengakses mikrofon dan kamera web anda."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Sila pilih fail"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Sila masukkan nama fail"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Sila masukkan URL video yang sah daripada platform disokong."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Sila pilih fail daripada jenis yang disokong"
  },
  "plus_d43cd4ec": {
    "message": "Tambah"
  },
  "plus_minus_f8be2e83": {
    "message": "Tambah/Tolak"
  },
  "posted_when_a578f5ab": {
    "message": "Disiarkan: { when }"
  },
  "power_set_4f26f316": {
    "message": "Set Kuasa"
  },
  "precedes_196b9aef": {
    "message": "Mendahului"
  },
  "precedes_equal_20701e84": {
    "message": "Mendahului Sama Dengan"
  },
  "preformatted_d0670862": {
    "message": "Sedia Terformat"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Sebelumnya"
  },
  "preview_53003fd2": {
    "message": "Pratonton"
  },
  "preview_a3f8f854": {
    "message": "PRATONTON"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Pratonton dalam tindihan"
  },
  "preview_inline_9787330": {
    "message": "Pratonton dalam sebaris"
  },
  "previous_bd2ac015": {
    "message": "Sebelumnya"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Sebelumnya { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Warna yang dipilih sebelum ini"
  },
  "prime_917ea60e": {
    "message": "Perdana"
  },
  "prime_numbers_13464f61": {
    "message": "Nombor Perdana"
  },
  "product_39cf144f": {
    "message": "Produk"
  },
  "proportional_f02800cc": {
    "message": "Berkadaran"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokol mestilah terdiri daripada ftp, http, mailto, skype, tel atau boleh ditinggalkan."
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "telah diterbitkan"
  },
  "published_when_302d8e23": {
    "message": "Diterbitkan: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Labu"
  },
  "purple_7678a9fc": {
    "message": "Ungu"
  },
  "quaternions_877024e0": {
    "message": "Kuarternion"
  },
  "quiz_e0dcce8f": {
    "message": "Kuiz"
  },
  "quizzes_7e598f57": {
    "message": "Kuiz"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Nombor Rasional"
  },
  "real_numbers_7c99df94": {
    "message": "Nombor Sebenar"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Bahagian Sebenar (Nombor Kompleks)"
  },
  "record_7c9448b": {
    "message": "Rakam"
  },
  "record_upload_media_5fdce166": {
    "message": "Rakam/Muat Naik Media"
  },
  "recording_98da6bda": {
    "message": "Merakam"
  },
  "red_8258edf3": {
    "message": "Merah"
  },
  "relationships_6602af70": {
    "message": "Hubungan"
  },
  "religion_icon_246e0be1": {
    "message": "Ikon Agama"
  },
  "remove_f47dc62a": {
    "message": "Alih Keluar"
  },
  "remove_filename_3ea029f6": {
    "message": "Alih keluar { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Alih keluar gaya tajuk"
  },
  "remove_link_d1f2f4d0": {
    "message": "Alih Keluar Pautan"
  },
  "replace_all_d3d68b3": {
    "message": "Gantikan Semua"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Gantikan semua { findText } dengan { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Gantikan"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Gantikan semua { findText } dengan { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Gantikan dengan"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Gantikan semua { alertFindText } dengan { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Gantikan semua { alertFindText } dengan { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Tetap Semula"
  },
  "resize_ec83d538": {
    "message": "Saiz Semula"
  },
  "restore_auto_save_deccd84b": {
    "message": "Pulihkan penyimpanan automatik?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Keputusan { index } daripada { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Paku Kiri (Tiada Keluaran)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Varian)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editor Kandungan Beraneka"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Kawasan Teks Beraneka. Tekan { OSKey }+F8 untuk pintasan Editor Kandungan Beraneka"
  },
  "right_71ffdc4d": {
    "message": "Kanan"
  },
  "right_align_39e7a32a": {
    "message": "Jajar ke Kanan"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Tanda Kurung Sudut Kiri"
  },
  "right_arrow_35e0eddf": {
    "message": "Anak Panah ke Kanan"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Panah Cangkuk Kanan"
  },
  "right_ceiling_839dc744": {
    "message": "Siling Kanan"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Tanda Kurung Dakap Kanan"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Panah Tempuling Tegak Bawah Kanan"
  },
  "right_floor_5392d5cf": {
    "message": "Lantai Kanan"
  },
  "right_to_left_9cfb092a": {
    "message": "Kanan ke Kiri"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Panah Tempuling Tegak Atas Kanan"
  },
  "rightward_arrow_32932107": {
    "message": "Panah Tunjuk Kanan"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Segi Tiga Tunjuk Kanan"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Putar imej -90 darjah"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Putar imej 90 darjah"
  },
  "rotation_9699c538": {
    "message": "Putaran"
  },
  "row_fc0944a7": {
    "message": "Baris"
  },
  "row_group_979f5528": {
    "message": "Kumpulan baris"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Sayangnya, editor HTML rapi tidak dapat diakses dengan papan kekunci. Dapatkan akses kepada editor HTML mentah di sini."
  },
  "save_11a80ec3": {
    "message": "Simpan"
  },
  "save_copy_ca63944e": {
    "message": "Simpan Salinan"
  },
  "save_media_cb9e786e": {
    "message": "Simpan Media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Ikon Pembuat Ikon Disimpan"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Pembaca skrin tidak boleh menentukan apa yang dipaparkan dalam imej tanpa teks alternatif dan nama fail selalunya merupakan rentetan nombor dan huruf tidak bermakna yang tidak menerangkan konteks atau makna."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Pembaca skrin tidak boleh menentukan apa yang dipaparkan dalam imej tanpa teks alternatif yang menerangkan kandungan dan makna imej. Teks alternatif sepatutnya mudah dan ringkas."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Pembaca skrin tidak boleh menentukan apa yang dipaparkan dalam imej tanpa teks alternatif yang menerangkan kandungan dan makna imej."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Pembaca skrin tidak boleh menterjemahkan jadual tanpa struktur yang betul. Pengepala jadual memberikan arah tuju dan skop kandungan."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Pembaca skrin tidak boleh menterjemahkan jadual tanpa struktur yang betul. Kapsyen jadual menerangkan konteks dan pemahaman umum tentang jadual."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Pembaca skrin tidak boleh menterjemahkan jadual tanpa struktur yang betul. Pengepala jadual memberikan arah tuju dan gambaran keseluruhan kandungan."
  },
  "script_l_42a7b254": {
    "message": "Skrip L"
  },
  "search_280d00bd": {
    "message": "Cari"
  },
  "select_audio_source_21043cd5": {
    "message": "Pilih sumber audio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Pilih bentuk pangkasan"
  },
  "select_language_7c93a900": {
    "message": "Pilih Bahasa"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Pilih sumber video"
  },
  "selected_274ce24f": {
    "message": "Dipilih"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } dipilih"
  },
  "selection_b52c4c5e": {
    "message": "Pilihan"
  },
  "set_header_scope_8c548f40": {
    "message": "Tetapkan skop pengepala"
  },
  "set_minus_b46e9b88": {
    "message": "Tetapkan Tolak"
  },
  "set_table_header_cfab13a0": {
    "message": "Tetapkan pengepala jadual"
  },
  "sharp_music_ab956814": {
    "message": "Tajam (Muzik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Anak Panah"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift+O untuk membuka editor HTML rapi."
  },
  "shortcut_911d6255": {
    "message": "Pintasan"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Tunjuk pilihan imej"
  },
  "show_link_options_545338fd": {
    "message": "Tunjuk pilihan pautan"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Tunjuk penggulungan transkrip"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Tunjuk Penggulungan Transkrip"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Pengguna yang menggunakan penglihatan untuk memperoleh maklumat menyemak imbas halaman web dengan pantas untuk mencari tajuk yang besar dan tebal. Pengguna pembaca skrin bergantung pada pengepala untuk memperoleh pemahaman kontekstual. Pengepala sepatutnya menggunakan struktur yang betul."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Pengguna yang menggunakan penglihatan untuk memperoleh maklumat menyemak imbas halaman web dengan pantas untuk mencari tajuk yang besar dan tebal. Pengguna pembaca skrin bergantung pada pengepala untuk memperoleh pemahaman kontekstual. Pengepala sepatutnya ringkas dan berada dalam struktur yang betul."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Varian)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Imej Warna Tunggal"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Warna Imej Warna Tunggal"
  },
  "size_b30e1077": {
    "message": "Saiz"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Saiz fail kapsyen lebih besar daripada saiz maksimum { max } kb yang dibenarkan."
  },
  "small_b070434a": {
    "message": "Kecil"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Kecil ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Bulatan Satu Warna"
  },
  "something_went_wrong_89195131": {
    "message": "Sesuatu tidak kena."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Sesuatu tidak kena semasa mengakses kamera web anda."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Sesuatu tidak kena dan saya tidak pasti perkara yang patut ditunjukkan."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Sesuatu tidak kena. Semak sambungan anda, muatkan semula halaman dan cuba semula."
  },
  "something_went_wrong_d238c551": {
    "message": "Sesuatu tidak kena"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Sesuatu tidak kena semasa berkongsi skrin anda."
  },
  "sort_by_e75f9e3e": {
    "message": "Isih Mengikut"
  },
  "spades_suit_b37020c2": {
    "message": "Penyodok (Sut)"
  },
  "square_511eb3b3": {
    "message": "Segi empat"
  },
  "square_cap_9ec88646": {
    "message": "Topi Segi Empat"
  },
  "square_cup_b0665113": {
    "message": "Cawan Segi Empat"
  },
  "square_root_e8bcbc60": {
    "message": "Punca Kuasa Dua"
  },
  "square_root_symbol_d0898a53": {
    "message": "Simbol Punca Kuasa Dua"
  },
  "square_subset_17be67cb": {
    "message": "Subset Kuasa Dua"
  },
  "square_subset_strict_7044e84f": {
    "message": "Subset Kuasa Dua (Wajar)"
  },
  "square_superset_3be8dae1": {
    "message": "Superset Kuasa Dua"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Subset Kuasa Dua (Wajar)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "senarai tidak tersusun segi empat sama"
  },
  "star_8d156e09": {
    "message": "Bintangkan"
  },
  "start_over_f7552aa9": {
    "message": "Mulakan Semula"
  },
  "start_recording_9a65141a": {
    "message": "Mulakan Rakaman"
  },
  "steel_blue_14296f08": {
    "message": "Biru Keluli"
  },
  "studio_media_options_ee504361": {
    "message": "Pilihan Media Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Dulang Pilihan Media Studio"
  },
  "styles_2aa721ef": {
    "message": "Gaya"
  },
  "submit_a3cc6859": {
    "message": "Serahkan"
  },
  "submitting_b90fac62": {
    "message": "Menyerahkan..."
  },
  "subscript_59744f96": {
    "message": "Subskrip"
  },
  "subset_19c1a92f": {
    "message": "Subset"
  },
  "subset_strict_8d8948d6": {
    "message": "Subset (Wajar)"
  },
  "succeeds_9cc31be9": {
    "message": "Berjaya"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Berjaya Sama Dengan"
  },
  "sum_b0842d31": {
    "message": "Jumlah"
  },
  "superscript_8cb349a2": {
    "message": "Superskrip"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Superskrip dan Subskrip"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Wajar)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Jenis fail yang disokong: SRT atau WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Tukar kepada Editor HTML rapi"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Tukar kepada Editor HTML mentah"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Tukar kepada editor HTML"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Tukar kepada editor teks beraneka"
  },
  "syllabus_f191f65b": {
    "message": "Silibus"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Audio Sistem Dibenarkan"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Audio Sistem Dinyahdayakan"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Panah"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Pengepala jadual bermula dengan { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Jadual bermula dengan { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Pengepala jadual sepatutnya menentukan skop."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Jadual sepatutnya termasuk kapsyen yang menerangkan kandungan jadual."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Jadual sepatutnya termasuk sekurang-kurangnya satu pengepala."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Teal"
  },
  "text_7f4593da": {
    "message": "Teks"
  },
  "text_background_color_16e61c3f": {
    "message": "Warna Latar Belakang Teks"
  },
  "text_color_acf75eb6": {
    "message": "Warna Teks"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Teks sukar untuk dibaca tanpa kontras yang mencukupi antara teks dan latar belakang, terutamanya untuk mereka yang mempunyai penglihatan rendah."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Teks yang lebih besar daripada 18pt (atau tebal 14pt) sepatutnya memaparkan nisbah kontras minimum 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Teks (pilihan)"
  },
  "text_position_8df8c162": {
    "message": "Kedudukan Teks"
  },
  "text_size_887c2f6": {
    "message": "Saiz Teks"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Teks yang lebih kecil daripada 18pt (atau tebal 14pt) sepatutnya memaparkan nisbah kontras minimum 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Pratonton dokumen sedang diproses pada masa ini. Sila cuba semula kemudian."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Pengepala pertama pada halaman sepatutnya bersaiz H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Ketinggian Kawasan Kandungan Beraneka dikurangkan."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Ketinggian Kawasan Kandungan Beraneka ditambahkan."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Bahan berada dalam domain awam"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Bahan dilesenkan di bawah Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Bahan ini tertakluk pada pengecualian - cth. penggunaan adil, hak untuk kuota atau lain-lain hak bawah undang-undang hak cipta yang terpakai"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Editor HTML rapi tidak dapat diakses dengan papan kekunci. Tekan Shift+O untuk membuka editor HTML rapm"
  },
  "therefore_d860e024": {
    "message": "Oleh itu"
  },
  "theta_ce2d2350": {
    "message": "Teta"
  },
  "theta_variant_fff6da6f": {
    "message": "Teta (Varian)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Panah Tegak Bawah Tebal"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Panah Kiri Tebal"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Panah ke Kiri Tebal"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Panah Kanan Tebal"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Panah ke Kanan Tebal"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Panah Tegak Atas Tebal"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dokumen ini tidak boleh dipaparkan dalam Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Persamaan ini tidak boleh dipaparkan dalam Paparan Asas"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Imej ini tidak tersedia pada masa ini."
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Video ini mungkin mempamerkan iklan YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Walaupun video anda akan mempunyai tajuk yang betul dalam pelayar, kami gagal membuat kemas kini dalam pangkalan data."
  },
  "thumbnail_e0de666f": {
    "message": "Imej Kecil"
  },
  "timebar_a4d18443": {
    "message": "Bar Masa"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Tajuk tidak boleh dibiarkan kosong"
  },
  "title_ee03d132": {
    "message": "Tajuk"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Untuk Disiarkan: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Untuk Dilakukan: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Togol { summary } kumpulan"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Togol petua alat"
  },
  "tools_2fcf772e": {
    "message": "Alat"
  },
  "top_66e0adb6": {
    "message": "Atas"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Panel transkrip tersedia pada kelebaran melebihi 720px."
  },
  "tray_839df38a": {
    "message": "Dulang "
  },
  "triangle_6072304e": {
    "message": "Segi Tiga"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Paku (Keluaran)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "taip Control 9 untuk mengakses pilihan imej. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "taip Control 9 untuk mengakses pilihan pautan. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "taip Control 9 untuk mengakses pilihan jadual. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Tidak dapat menentukan url pilihan sumber"
  },
  "underline_applied_ae01ec97": {
    "message": "Garis bawah digunakan"
  },
  "underline_removed_3693e17c": {
    "message": "Garis bawah dialih keluar"
  },
  "union_e6b57a53": {
    "message": "Kesatuan"
  },
  "unpublished_dfd8801": {
    "message": "dinyahterbitkan"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Apa-apa perubahan yang tidak disimpan akan hilang."
  },
  "untitled_16aa4f2b": {
    "message": "Tidak bertajuk"
  },
  "untitled_efdc2d7d": {
    "message": "tidak bertajuk"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Panah Barat Laut"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Panah Timur Laut"
  },
  "up_c553575d": {
    "message": "Ke atas"
  },
  "updated_link_a827e441": {
    "message": "Pautan dikemas kini"
  },
  "upload_document_253f0478": {
    "message": "Muat Naik Dokumen"
  },
  "upload_file_fd2361b8": {
    "message": "Muat Naik Fail"
  },
  "upload_image_6120b609": {
    "message": "Muat Naik Imej"
  },
  "upload_media_ce31135a": {
    "message": "Muat Naik Media"
  },
  "upload_record_media_e4207d72": {
    "message": "Muat Naik/Rakam Media"
  },
  "uploading_19e8a4e7": {
    "message": "Sedang memuat naik"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "senarai tersusun mengikut abjad huruf besar"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta Huruf Besar"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gama Huruf Besar"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda Huruf Besar"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega Huruf Besar"
  },
  "uppercase_phi_caa36724": {
    "message": "Fi Huruf Besar"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi Huruf Besar"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi Huruf Besar"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "senarai tersusun nombor Rumi huruf besar"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma Huruf Besar"
  },
  "uppercase_theta_49afc891": {
    "message": "Teta Huruf Besar"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon Huruf Besar"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi Huruf Besar"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Panah Tunjuk Bawah dan Atas"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Panah Tunjuk Bawah dan Atas (Tebal)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Panah Tegak Atas"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Segi Tiga Tunjuk Atas"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Hak Penggunaan:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Hak Penggunaan (diperlukan)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Gunakan kekunci anak panah untuk menavigasi pilihan."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Gunakan kekunci anak panah untuk memilih bentuk."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Gunakan kekunci anak panah untuk memilih saiz."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Gunakan kekunci anak panah untuk memilih kedudukan teks."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Gunakan kekunci anak panah untuk memilih saiz teks."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Gunakan kekunci anak panah untuk memilih saiz garis luar."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Digunakan oleh pembaca skrin untuk menerangkan kandungan { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Digunakan oleh pembaca skrin untuk menerangkan kandungan imej"
  },
  "user_documents_c206e61f": {
    "message": "Dokumen Pengguna"
  },
  "user_files_78e21703": {
    "message": "Fail Pengguna"
  },
  "user_images_b6490852": {
    "message": "Imej Pengguna"
  },
  "user_media_14fbf656": {
    "message": "Media Pengguna"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (Notasi)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Bar Menegak (Notasi Set Pembina)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Titik Menegak"
  },
  "video_options_24ef6e5d": {
    "message": "Pilihan Video"
  },
  "video_options_tray_3b9809a5": {
    "message": "Dulang Pilihan Video"
  },
  "video_player_b371005": {
    "message": "Pemain Video"
  },
  "video_player_for_9e7d373b": {
    "message": "Pemain video untuk  "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Pemain video untuk { title }"
  },
  "video_url_889d3263": {
    "message": "URL video"
  },
  "view_all_e13bf0a6": {
    "message": "Lihat Semua"
  },
  "view_ba339f93": {
    "message": "Lihat"
  },
  "view_description_30446afc": {
    "message": "Lihat penerangan"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Lihat pintasan papan kekunci"
  },
  "view_title_description_67940918": {
    "message": "Lihat penerangan { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Lihat bilangan perkataan dan aksara"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Sekatan Penonton"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Kami tidak dapat mengesan mikrofon berfungsi yang disambungkan dengan peranti anda."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Kami tidak dapat mengesan kamera web berfungsi yang disambungkan dengan peranti anda."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Kami tidak dapat mengesan kamera web atau mikrofon berfungsi yang disambungkan dengan peranti anda."
  },
  "webcam_disabled_30c66986": {
    "message": "Kamera Web Dinyahdayakan"
  },
  "webcam_fe91b20f": {
    "message": "Kamera Web"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Halaman web sepatutnya hanya mempunyai satu H1 yang digunakan oleh Tajuk halaman secara automatik. Pengepala pertama dalam kandungan anda sepatutnya H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Apabila tanda digunakan untuk memformat item secara visual sebagai senarai tetapi petunjuk tidak diberikan tentang hubungan senarai, pengguna mungkin mengalami kesukaran dalam menavigasi maklumat."
  },
  "white_87fa64fd": {
    "message": "Putih"
  },
  "why_523b3d8c": {
    "message": "Kenapa"
  },
  "width_492fec76": {
    "message": "Lebar"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Lebar dan tinggi mestilah dalam bentuk nombor"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } piksel"
  },
  "wiki_home_9cd54d0": {
    "message": "Laman Utama Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Bilangan Perkataan"
  },
  "words_b448b7d5": {
    "message": "Perkataan"
  },
  "wreath_product_200b38ef": {
    "message": "Produk Lingkaran Bunga"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ya"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Anda sedang menggunakan pelet warna. Gunakan butang ''W'', ''A'', ''S'' dan ''D''’ , masing-masing untuk menavigasi pelet ke atas, ke kiri, ke bawah dan ke kanan."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Anda sedang menggunakan peluncur warna. Gunakan butang  ''A'' and ''D'', masing-masing untuk menavigasi peluncur ke kiri atau ke kanan."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Anda sedang menggunakan peluncur alfa. Gunakan butang  ''A'' and ''D'', masing-masing untuk menavigasi peluncur ke kiri atau ke kanan."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Anda mempunyai perubahan tidak disimpan dalam dulang Pembuat Ikon. Adakah anda ingin menerukan tanpa menyimpan perubahan ini?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Anda mungkin perlu melaraskan pengepala tambahan untuk mengekalkan hierarki halaman."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Anda tidak boleh memuatkan fail kosong."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Imej anda telah dimampatkan untuk Pembuat Ikon. Imej yang kurang daripada { size } KB tidak akan dimampatkan."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofon anda disekat dalam tetapan pelayar."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Kamera web dan mikrofon anda disekat dalam tetapan pelayar."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Kamera web anda disekat dalam tetapan pelayar."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Kamera web anda mungkin sudah digunakan."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL benam YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zum"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zum masuk imej"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zum keluar imej"
  }
};
formatMessage.addLocale({
  ms: locale
});